import { createStyles, makeStyles } from '@material-ui/core/styles';
import { INFO_BLUE, INFO_BLUE_BORDER, INFO_BLUE_LIGHT } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    dialogTitleStyle: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeIcon: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    submitButton: {
      display: 'flex',
      margin: theme.spacing(1, 2, 3, 0),
      alignItems: 'flex-end',
      gap: '1rem'
    },
    infoBox: {
      backgroundColor: INFO_BLUE_LIGHT,
      border: `1px solid ${INFO_BLUE_BORDER}`,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2),
      margin: theme.spacing(3, 0, 1, 0)
    },
    infoBoxHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1.5)
    },
    infoBoxIcon: {
      color: INFO_BLUE,
      flexShrink: 0,
      fontSize: '1.375rem'
    },
    infoBoxTitle: {
      margin: 0,
      color: INFO_BLUE,
      fontSize: '1.125rem',
      lineHeight: 1.2
    },
    infoBoxParagraph: {
      margin: theme.spacing(0, 0, 1, 0),
      '&:last-child': {
        marginBottom: 0
      }
    }
  });
});